// extracted by mini-css-extract-plugin
export default {"viewItem":"material-info_viewItem__jvDr9","viewItemValue":"material-info_viewItemValue__s7MHH","container":"material-info_container__8H5qV"};